// store/modules/locationNode/actions.js
import LocationNodeApi from "../../../api/modules/LocationNodeApi";

export const loadAllLocationNodes = async ({ commit }, payload) => {
  try {
    const { context } = payload;
    return await LocationNodeApi.loadAllLocationNodes(context);
  } catch (error) {
    console.error("Error al cargar nodos de ubicación:", error);
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/locationNode/actions.js